import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses, Refresher } from "@green24/npm-javascript-utils";
import Fa from "../../components/shared/Fa";
import Interpret from "../../components/shared/Localization/Interpret";
import { configurationThunk, locationThunk } from "../../store/store";
import withConfiguration from "../../components/shared/hoc/withConfiguration";
import { TranslatedText } from "../../components/components";

class OutOfOrderPage extends Component {
	componentDidMount() {
		this._refresher = new Refresher(() => {
			const {configuration} = this.props;

			if(configuration?.locationID) {
				locationThunk.getLocation(configuration.locationID).catch(() => null).finally(() => {
					this._refresher.trigger();
				});
			}
			else {
				configurationThunk.getConfiguration().catch(() => null).finally(() => {
					this._refresher.trigger();
				});
			}
		}, 10000, false);
	}

	componentWillUnmount() {
		this._refresher && this._refresher.stop();
	}

	//TBD: Split into a separate method so it can cover multiple error states
	_renderMessage() {
		const {message, messageTranslated, messageTranslationParams, error} = this.props;

		return <>
			<Fa className={"logo"} icon={"cubesave-logo-vertical"}/>

			<div className={"error"}>
				<div className={"icon-wrapper"}>
					<Fa icon={"exclamation-triangle"}/>
				</div>

				<h1><Interpret id={"location.outOfOrder"}/></h1>
				{
					message &&
					<p><TranslatedText text={message} textTranslated={messageTranslated} translationParams={messageTranslationParams}/></p>
				}
				{
					error?.message &&
					<p>{error.statusCode} {error.message}</p>
				}
			</div>
		</>;
	}

	render({className, style}) {
		return (
			<section className={combineClasses("out-of-order-page", className)} style={style}>
				{this._renderMessage()}
			</section>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			error: PropTypes.object,

			message: PropTypes.string,
			messageTranslated: PropTypes.bool,
			messageTranslationParams: PropTypes.object,

			configuration: PropTypes.object,
		}
	}
}

export default withConfiguration(OutOfOrderPage);
